import { useMemo } from "react";


export interface PliableBlockParams {
    jsonData: any;
}

interface PliableAnalysisDSL {
    name: string;
    metrics: string[];
    dimensions: string[];
    filters: {
        dimension: string;
        comparator: string;
        value: string[];
    }[];
    visualization: string;
}

export const PliableBlock = (params: PliableBlockParams) => {
    const parsedJSON = useMemo(() => {
        try {
            return JSON.parse(params.jsonData) as PliableAnalysisDSL;
        } catch (e) {
            return null;
        }
    }, [params.jsonData]);

    if (!parsedJSON) {
        return <p>Generating...</p>
    }
    return <div>
        <h3>{parsedJSON.name}</h3>
        <p>Visualization: {parsedJSON.visualization}</p>
        <p>Metrics: {parsedJSON.metrics.join(', ')}</p>
        <p>Dimensions: {parsedJSON.dimensions.join(', ')}</p>
        <p>Filters: {parsedJSON.filters.map(f => `${f.dimension} ${f.comparator} ${f.value.join(', ')}`).join(', ')}</p>
    </div>
}